import React from 'react';
import { CurrencyIcon } from 'lucide-react';

const PayrollEmptyState = () => {
  return (
    <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-12 text-center dark:bg-gray-800/80">
      <div className="mx-auto h-24 w-24 bg-indigo-100 dark:bg-indigo-900/30 rounded-full flex items-center justify-center">
        <CurrencyIcon className="h-12 w-12 text-indigo-600 dark:text-indigo-400" />
      </div>
      <h3 className="mt-6 text-xl font-medium text-gray-900 dark:text-gray-100">No payroll records yet</h3>
      <p className="mt-2 text-gray-500 dark:text-gray-400">
        Your payroll history will appear here once processed
      </p>
    </div>
  );
};

export default PayrollEmptyState;
